import { render, staticRenderFns } from "./AuthorizedFallback.vue?vue&type=template&id=1242402b"
import script from "./AuthorizedFallback.vue?vue&type=script&lang=js"
export * from "./AuthorizedFallback.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports